import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LoanMappingListSF from '../util/LoanMappingListSF'

const SecurityCoverUI = ({ context, loan, loanInterestRate, onRefreshClick }) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Security cover</b></span>
        </div>
      }
      right={<span />}
    />

    <SecurityCoverTableUI context={context} loanInterestRate={loanInterestRate} onRefreshClick={onRefreshClick}
    />

    <LoanMappingListSF context={context} loan={loan} category='security_cover' categoryLabel='Additional security cover lines' />

    <SecurityCoverRateTableUI />
  </div>

const SecurityCoverTableUI = ({ loanInterestRate }) =>
  <div className='g_m_top_100'>
    <CardUI title='Security cover'>
      <table className='g_table'>
        <thead className='g_sticky'><tr>
          <td className='g_text_center'><b>Nature of Security</b></td>
          <td className='g_text_center'><b>Expected Value</b></td>
        </tr></thead>
        <tbody>
          {
            loanInterestRate &&
            <>
              {
                loanInterestRate.scAdditionalParamList.map((param, i) =>
                  <tr key={i}>
                    <td>{param.natureOfSecurity}</td>
                    <td className='g_text_right'>{param.expectedValueF4}</td>
                  </tr>
                )
              }
              <Row1UI
                lir='residualValue'
                value={loanInterestRate.residualValueF4}
              />

              <Row1UI
                lir='dsra'
                value={loanInterestRate.dsraF4}
              />

              <Row1UI
                lir='charge'
                value={loanInterestRate.chargeValueF4}
              />
              <Row1UI
                lir='total'
                value={loanInterestRate.securityTotalF4}
                total={true}
              />
              <Row1UI
                lir='loanAmountApproved'
                value={loanInterestRate.loanAmountF4}
              />
              <Row1UI
                lir='cover'
                value={loanInterestRate.securityCover}
                total={true}
              />
            </>
          }
        </tbody>
      </table>
    </CardUI>
    <CardUI className='g_m_top_100' title='Residual value break up'>
      <table className='g_table'>
        <thead>
          <tr>
            <th>Vendor Name</th>
            <th className='g_p_left_100'>Item Details</th>
            <th className='g_p_left_100'>Amount</th>
            <th className='g_p_left_100'>Residual Value</th>
            <th className='g_p_left_100'>Residual Percent</th>
          </tr>
        </thead>
        <tbody>
          {
            loanInterestRate.residualValueList.map((value, i) =>
              <tr key={i}>
                <td>{value.vendorName}</td>
                <td className='g_p_left_100'>{value.itemDetails}</td>
                <td className='g_text_right g_p_left_100'>{value.amountF4}</td>
                <td className='g_text_right g_p_left_100'>{value.residualValueF4}</td>
                <td className='g_text_right g_p_left_100'>{value.residualPercent}</td>
              </tr>
            )}
        </tbody>
      </table>
    </CardUI>
  </div>

const SecurityCoverRateTableUI = () =>
  <CardUI className='g_m_top_100' >
    <table className='g_table'>
      <thead className='g_sticky'><tr>
        <td className='g_text_center'><b>Security Cover</b></td>
        <td className='g_text_center'><b>Security Cover Rate</b></td>
      </tr></thead>
      <tbody>
        <tr>
          <td>
            {'>'}=2.25x
          </td>
          <td className='g_text_right'>
            0.00%
          </td>
        </tr>
        <tr>
          <td>
            {'>'}=2x and {'<'}2.25x
          </td>
          <td className='g_text_right'>
            0.40%
          </td>
        </tr>
        <tr>
          <td>
            {'>'}=1.75x and {'<'}2x
          </td>
          <td className='g_text_right'>
            0.80%
          </td>
        </tr>
        <tr>
          <td>
            {'>'}=1.5x and {'<'}1.75x
          </td>
          <td className='g_text_right'>
            1.20%
          </td>
        </tr>
        <tr>
          <td>
            {'>'}=1.3x and {'<'}1.5x
          </td>
          <td className='g_text_right'>
            1.60%
          </td>
        </tr>
      </tbody>
    </table>
  </CardUI>

const Row1UI = ({ lir, value, total, }) =>
  <>
    <tr className={total && 'g_table_total'}>
      <td>
        <Desc lir={lir} />
      </td>
      <td className='g_text_right'>
        {value}
      </td>
    </tr>
  </>

const Desc = ({ lir }) =>
  <span>
    {(() => {
      switch (lir) {
        case 'dsra':
          return 'Security - DSRA'
        case 'residualValue':
          return 'Security - Residual Value'
        case 'charge':
          return 'Security - Charge on current & movable assets'
        case 'total':
          return 'Total'
        case 'loanAmountApproved':
          return 'Loan Amount Approved'
        case 'cover':
          return 'Cover'
        case 'opportunityCost':
          return 'Opportunity Cost (Risk free FD interest rate)'
        case 'cost':
          return 'Cost to be incurred by Clime'
        case 'baseRate':
          return 'Base Rate'
        case 'spread':
          return 'Spread'
        case 'reduction':
          return 'Reduction on account on DSRA*'
        case 'minimumLendingRate':
          return 'Minimum lending rate to be charged from clients'
        case 'securityCover':
          return 'Security Cover'
        case 'tenorPremium':
          return 'Tenor Premium for > 12 months deal'
        case 'escrowCoverage':
          return 'Escrow Coverage'
        case 'ratingPremium':
          return 'Rating Premium'
        case 'womenStakeholder':
          return 'Women stakeholder'
        case 'ppaRebateRate':
          return 'Rebate for "A" rated or above counterparty (in PPA only)'
        case 'repeatTxnRebateRate':
          return 'Rebate for Repeat Transaction'
        case 'cashFlowRebateRate':
          return 'Rebate for contracted cashflow'
        case 'finalRate':
          return 'Final rate'
        default:
          return lir
      }
    })()}
  </span>

export default SecurityCoverUI
